module.exports = __webpack_public_path__ + "h5/img/people.ea368998.png";